import classNames from 'classnames'
import { useTranslation } from 'next-i18next'

import Icon from '../icon'
import OutOfStockIcon from '../productForm/icons/outOfStock.inline.svg'

import { ProductCTAConstants } from './constants'
import styles from './productCTA.module.scss'
import { DisplayTextType } from './types'

export const ProductDisplayText = ({
  date,
  className,
  isQuickATCForMobile,
  showNewPdpUI,
  showNewPdpDesignV2,
}: DisplayTextType) => {
  const { t } = useTranslation('common')

  return (
    <div
      className={classNames(
        styles.displayTextWrapper,
        className,
        isQuickATCForMobile && styles.displayTextWrapper__quickATC,
        showNewPdpUI && styles.displayTextWrapper_adjustedPadding,
      )}
    >
      {showNewPdpDesignV2 ? <Icon iconSvg={OutOfStockIcon} className={styles.oosIcon} /> : null}
      {t(ProductCTAConstants.OUT_OF_STOCK)}
      {date ? t('var1_date', { var1: t(ProductCTAConstants.BACK_IN_STOCK), date: date }) : ''}
    </div>
  )
}
